document.addEventListener("DOMContentLoaded", function() {
    let selectElement = document.getElementById("ContactForm-subject");
  
    selectElement.addEventListener("change", function() {
      let selectedValue = selectElement.value;
      let targetChangeColor = document.getElementById("ContactForm-subject");
  
      if (selectedValue != "subject") {
        targetChangeColor.style.color = "#000";
      }else{
        targetChangeColor.style.color = "";
      }
    });
  });
  